// extracted by mini-css-extract-plugin
export var md = "_2e-4";
export var semantic = "_2e-5";
export var sm = "_2e-3";
export var text = "_2e-6";
export var toggleInput = "_2e-0";
export var toggleSwitch = "_2e-1";
export var xs = "_2e-2";